import i18n from '@/i18n';
import { CommonDateRange } from '@/infrastructure/utils/timestamp';


export enum TimeQuickShortcut {
  Last1Hour = '近1小时',
  Today = '今天',
  Yesterday = '昨天',
  Last1Day = '近1天',
  Last2Days = '近2天',
  Last7Days = '近7天',
  Last15Days = '近15天',
  Last30Days = '近30天',
  Last45Days = '近45天',
  Last90Days = '近90天',
  Last180Days = '近180天',
  Custom = 'custom',
}


export const COMMON_SHORT_RANGES = [
  {
    text: i18n.t(TimeQuickShortcut.Last1Hour),
    shortCut: TimeQuickShortcut.Last1Hour,
    value: () => CommonDateRange.hour(),
  },
  {
    text: i18n.t(TimeQuickShortcut.Today),
    shortCut: TimeQuickShortcut.Today,
    value: () => CommonDateRange.today(),
  },
  {
    text: i18n.t(TimeQuickShortcut.Yesterday),
    shortCut: TimeQuickShortcut.Yesterday,
    value: () => CommonDateRange.yesterday(),
  },
  {
    text: i18n.t(TimeQuickShortcut.Last7Days),
    shortCut: TimeQuickShortcut.Last7Days,
    value: () => CommonDateRange.lastDaysFull(7),
  },
  {
    text: i18n.t(TimeQuickShortcut.Last30Days),
    shortCut: TimeQuickShortcut.Last30Days,
    value: () => CommonDateRange.lastDaysFull(30),
  },
  {
    text: i18n.t(TimeQuickShortcut.Last90Days),
    shortCut: TimeQuickShortcut.Last90Days,
    value: () => CommonDateRange.lastDaysFull(90),
  },
];
